import React from 'react';
import logo from './logo.png'
import './App.css';
import { Routes, Route, useNavigate, Link } from 'react-router';
import Home from './Pages/Home';
import { useState } from 'react';
import Work from './Pages/Work';
import Feed from './Pages/Feed';
import About from './Pages/About';
import Contact from './Pages/Contact';
import button1 from './images/button1.png'
import button2 from './images/button2.png'
import button3 from './images/button3.png'
import button4 from './images/button4.png'


export const headerStyling = {
  fontSize: "35px"
}

export const subheaderStyling = {
  fontSize: "21.5px"
}

const ButtonMap = new Map<number, any>([
  [1, button1],
  [2, button2],
  [3, button3],
  [4, button4]
])

const topMarginMap = new Map<number, any>([
  [1, "-3vh"],
  [2, "-2vh"],
  [3, "-2vh"],
  [4, "-1vh"]
])

function App() {

  return (
    <div style={{ backgroundColor: "#ffcc7c" }}>
      <NavHeader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/work" element={<Work />} />
        <Route path="/feed/:year?" element={<Feed />} />
      </ Routes>
    </div>
  );
}
function NavHeader() {


  return (
    <header className="App-header">
      <div style={{ display: 'flex', flexDirection: 'row', marginLeft: "-10vh", position: 'relative' }}>
        <Link to="/">
          {Logo()}
        </Link>
        <p>
          Bhargav Annigeri
        </p>
      </div>
      <div className="App-button-row">
        {NavButton("About Me", "/about", 1)}
        {NavButton("Contact", "/contact", 2)}
        {NavButton("My Work", "/work", 3)}
        {NavButton("What I'm Consuming", "/feed/", 4)}
      </div>
    </header>
  )
}

function Logo() {

  const [isHovering, setIsHovering] = useState(false);

  const handleMouseEnter = () => {
    setIsHovering(true);
  }

  const handleMouseLeave = () => {
    setIsHovering(false);
  }


  return (
    <img
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      src={logo}
      alt="logo"
      style={{ height: isHovering ? "28vh" : "30vh", transition: "0.5s" }}
    />
  )
}

function NavButton(text: string, path: string, type: number) {
  const buttonBack = ButtonMap.get(type)
  const topMargin = topMarginMap.get(type)

  const navigate = useNavigate();
  const handleClick = (event: any) => {
    console.log(event)
    navigate(path)
  }

  const [isHighlighted, setIsHighlighted] = useState(false);

  const handleMouseEnter = () => {
    setIsHighlighted(true)
  }

  const handleMouseLeave = () => {
    setIsHighlighted(false)
  }

  return (
    <div className={"App-nav-button"}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img
        src={buttonBack}
        alt=""
        style={{
          opacity: isHighlighted ? "100%" : "0%",
          height: "15vh",
          position: "absolute",
          width: "15vh",
          left: 0,
          top: topMargin,
          cursor: 'pointer',
        }}
      />
      <p style={{ alignItems: "center", justifyContent: "center", position: "absolute", width: '15vh', cursor: 'pointer' }}>
        {text}
      </p>
    </div>
  )
}

export default App;
